<div *ngIf="orderList.length === 0" class="alert alert-info">No Orders</div>

<div *ngIf="orderList.length > 0" class="list-group">
  <div class="orders" *ngFor="let order of orderList">
    <app-order [order]="order"></app-order>
  </div>
</div>